import styled, { css } from "styled-components";
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;
export const Row = styled.div(
  ({ $gap, $fullWidth }) => css`
    display: flex;
    flex-direction: row;
    gap: ${$gap || "1rem"};
    align-items: flex-end;
    width: ${$fullWidth ? "100%" : "auto"};
  `
);
export const FormGroup = styled.div`
  margin: 0;
  width: 100%;

  & .form-group {
    margin: 0;
  }
`;
export const EvidenceList = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacings.xxs};

    height: 105px;
    overflow-y: auto;
  `
);
export const EvidenceRow = styled(Row)`
  align-items: center;

  & svg {
    opacity: 0;
    transition: opacity 0.2s ease-in-out;
  }

  &:hover svg {
    opacity: 1;
  }
`;
export const IconButton = styled.div(
  ({ theme, $danger }) => css`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    cursor: pointer;
    padding: 0 8px;

    color: ${$danger ? theme.colors.variant.danger : theme.colors.text.primary};
  `
);
export const StyledLink = styled.span(
  ({ theme }) => css`
    font-size: 0.9rem;
    cursor: pointer;
    color: ${theme.colors.text.primary};
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;

    &:hover {
      text-decoration: underline;
    }
  `
);
